import { AppStoreDownloadButton } from '@/components/app-store-download-button'
import { PlayStoreDownloadButton } from '@/components/play-store-download-button'
import { T } from '@/components/t'

export const PricingDownload = () => {
    return (
        <div className="flex flex-col justify-center bg-neotaste rounded-lg w-full max-w-[1040px] gap-6 p-10">
            <T h1 t="pricing.cta" className="text-center text-[28px] md:text-[32px]" />
            <div className="flex gap-3 justify-center">
                <AppStoreDownloadButton />
                <PlayStoreDownloadButton />
            </div>
        </div>
    )
}
